<template>
    <!--
            作者：peng
            时间：2020-08-10
            描述：插件中心-高级签到
        -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="签到记录" name="signadv">
                    <Signadv v-if="activeName=='signadv'"></Signadv>
                </el-tab-pane>
                <el-tab-pane label="签到档案" name="archives">
                    <Archives v-if="activeName=='archives'"></Archives>
                </el-tab-pane>
                <el-tab-pane label="签到设置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import SignadvApi from '@/api/signadv.js';
    import Signadv from './signadv/index.vue';
    import Archives from './archives/archives.vue';
    import Setting from './setting/setting.vue';
    export default {
        components: {
            Signadv,
            Archives,
            Setting
        },
        data() {
            return {
                activeName: 'signadv',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/signadv/index.vue